import { mutatorAction } from 'satcheljs';
import type { AccountKey } from 'owa-client-types';
import { tryParse } from 'owa-datetime';
import { OcpsPoliciesFetchState } from '../store/schema/OutlookCloudPoliciesSchema';
import type { AccountOcpsPoliciesState } from '../store/schema/OutlookCloudPoliciesSchema';
import getStore from '../store/store';

export const setAccountPoliciesMutator: (
    accountKey: AccountKey,
    policies: AccountOcpsPoliciesState['policies'],
    expirationTime: string | null | undefined
) => void = mutatorAction(
    'setAccountPolicies',
    (
        accountKey: AccountKey,
        policies: AccountOcpsPoliciesState['policies'],
        expirationTime: string | null | undefined
    ): void => {
        // Normalize the service value before it enters the store so policy reads only handle valid
        // OwaDate values. Missing and malformed expiration times mean the cached policies do not
        // have a known refresh deadline.
        const parsedExpirationTime = expirationTime
            ? (tryParse('UTC', expirationTime) ?? undefined)
            : undefined;
        const existing = getStore().get(accountKey);
        if (existing) {
            existing.policies = policies;
            existing.expirationTime = parsedExpirationTime;
        } else {
            getStore().set(accountKey, {
                policies,
                fetchState: OcpsPoliciesFetchState.Succeeded,
                expirationTime: parsedExpirationTime,
            });
        }
    }
);
